import * as o from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/Lightbulb.es.js";
const t = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(a, { ref: r, ...e, weights: i }));
t.displayName = "LightbulbIcon";
const s = t;
export {
  s as Lightbulb,
  t as LightbulbIcon
};
